import React from 'react';

type Props = {
  size?: string | number;
  color?: string;
};

const InstagramIcon = ({ size = 36, color = '#B3B5B6' }: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width={size}
    height={size}
    viewBox="0 0 36 36"
  >
    <defs>
      <path
        id="q3n5bk67sa"
        d="M18 8.982c2.937 0 3.285.011 4.445.064 1.072.05 1.655.228 2.042.379.514.2.88.438 1.265.823.385.385.624.751.823 1.265.15.387.33.97.379 2.042.053 1.16.064 1.508.064 4.445 0 2.937-.011 3.285-.064 4.445-.05 1.072-.228 1.655-.379 2.043-.2.513-.438.88-.823 1.264-.385.385-.751.624-1.265.823-.387.15-.97.33-2.042.379-1.16.053-1.508.064-4.445.064-2.937 0-3.285-.011-4.445-.064-1.072-.049-1.655-.228-2.042-.379-.514-.2-.88-.438-1.265-.823-.385-.385-.624-.751-.823-1.264-.15-.388-.33-.97-.379-2.043-.053-1.16-.064-1.508-.064-4.445 0-2.937.011-3.285.064-4.445.049-1.072.228-1.655.379-2.042.2-.514.438-.88.823-1.265.385-.385.751-.624 1.265-.823.387-.15.97-.33 2.042-.379 1.16-.053 1.508-.064 4.445-.064m1.096-1.981c2.01.003 2.428.019 3.44.065 1.17.054 1.97.24 2.67.512.723.28 1.336.657 1.948 1.268.611.612.987 1.225 1.268 1.949.272.7.458 1.499.512 2.67.046 1.011.062 1.429.065 3.439L29 17.7v1.396c-.004 2.01-.02 2.428-.066 3.44-.054 1.17-.24 1.97-.512 2.67-.28.723-.657 1.336-1.268 1.948-.612.611-1.225.987-1.949 1.269-.7.271-1.499.457-2.67.51-1.011.047-1.429.063-3.439.066L18.3 29h-1.396c-2.01-.004-2.428-.02-3.44-.066-1.17-.054-1.97-.24-2.67-.511-.723-.282-1.336-.658-1.948-1.27-.611-.61-.987-1.224-1.269-1.948-.271-.7-.457-1.499-.51-2.67-.047-1.011-.063-1.429-.066-3.439v-2.192c.003-2.01.019-2.428.065-3.44.054-1.17.24-1.97.511-2.67.282-.723.658-1.336 1.27-1.948.61-.611 1.224-.987 1.948-1.268.7-.272 1.499-.458 2.67-.512 1.011-.046 1.429-.062 3.439-.065zm-1.074 5.368c-3.122 0-5.653 2.53-5.653 5.653 0 3.122 2.53 5.653 5.653 5.653 3.122 0 5.653-2.531 5.653-5.653 0-3.122-2.531-5.653-5.653-5.653zm0 1.983c2.026 0 3.67 1.643 3.67 3.67 0 2.026-1.644 3.67-3.67 3.67-2.027 0-3.67-1.644-3.67-3.67 0-2.027 1.643-3.67 3.67-3.67zm5.827-3.554c-.723 0-1.31.586-1.31 1.31 0 .722.587 1.309 1.31 1.309.723 0 1.31-.587 1.31-1.31 0-.723-.587-1.31-1.31-1.31z"
      />
    </defs>
    <g fill="none" fillRule="evenodd">
      <g>
        <g transform="translate(-1248 -132) translate(1248 132)">
          <mask id="cnt4nrxd5b" fill="#fff">
            <use xlinkHref="#q3n5bk67sa" />
          </mask>
          <use fill={color} xlinkHref="#q3n5bk67sa" />
          <g fill={color} mask="url(#cnt4nrxd5b)">
            <path d="M0 0H36V36H0z" />
          </g>
          <path d="M0 0H36V36H0z" />
        </g>
      </g>
    </g>
  </svg>
);

export default InstagramIcon;
